import { useEffect, useState } from 'react'
import './index.scss'

const EMPTY_IMAGE_SRC = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='

export default function SafeImage({ src, className = '', onError, ...props }) {
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    setHasError(false)
  }, [src])

  const shouldShowFallback = !src || hasError
  const imageClassName = ['SafeImage', className, shouldShowFallback ? 'SafeImage_error' : ''].filter(Boolean).join(' ')

  return (
    <img
      {...props}
      src={shouldShowFallback ? EMPTY_IMAGE_SRC : src}
      alt=""
      className={imageClassName}
      onError={(event) => {
        setHasError(true)
        onError?.(event)
      }}
    />
  )
}
